import { format } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { getExpense } from '../../api/sportaloka-client';
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import SelectMasterCost from '../../components/form/SelectMasterCost';

const Pengeluaran = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [paginationOptions, setPaginationOptions] = useState({
    tenant_cost: null,
    start_date: format(new Date(), 'yyyy-MM-dd'),
    end_date: format(new Date(), 'yyyy-MM-dd')
  });

  const getData = async () => {
    try {
      setLoading(true);
      setError(false);
      setData([]);
      setFilteredData([]);

      const query = new URLSearchParams({
        tenant_cost_id: paginationOptions.tenant_cost ? paginationOptions.tenant_cost.value : '',
        start_date: paginationOptions.start_date,
        end_date: paginationOptions.end_date
      }).toString();
      const response = await getExpense(query);

      const transformedData = response.data.data.flatMap((entry) =>
        entry.guest_costs.map((guestCost) => ({
          id: guestCost.id,
          date: entry.executed_at,
          remarks: `Biaya ${guestCost.tenant_cost.description} untuk tamu ${entry.fullname} dengan kode booking ${entry.booking.booking_code}`,
          amount: guestCost.tenant_cost.amount,
          tenant_cost_id: guestCost.tenant_cost.id
        }))
      );

      setData(transformedData);
      filterData(transformedData);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(true);
    }
  };

  const filterData = (allData) => {
    const filtered =
      paginationOptions.tenant_cost && paginationOptions.tenant_cost.value
        ? allData.filter((item) => item.tenant_cost_id === paginationOptions.tenant_cost.value)
        : allData;

    setFilteredData(filtered);
  };

  const handleFilterChange = (field, value) => {
    const updatedOptions = { ...paginationOptions, [field]: value };
    setPaginationOptions(updatedOptions);
    if (field === 'tenant_cost') {
      filterData(data);
    }
  };

  const downloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(
      filteredData.map((item) => ({
        Tanggal: format(new Date(item.date), 'yyyy/MM/dd HH:mm:ss'),
        Keterangan: item.remarks,
        Jumlah: `IDR ${item.amount.toLocaleString()}`
      }))
    );

    const totalExpense = filteredData.reduce((acc, curr) => acc + curr.amount, 0).toLocaleString();

    XLSX.utils.sheet_add_aoa(worksheet, [[], ['Total Pengeluaran', '', `IDR ${totalExpense}`]], {
      origin: -1
    });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Pengeluaran');
    XLSX.writeFile(workbook, 'LaporanPengeluaranTenant.xlsx');
  };

  const downloadPdf = () => {
    const doc = new jsPDF();
    doc.text('Laporan Pengeluaran', 10, 10);

    const tableData = filteredData.map((item) => [
      format(new Date(item.date), 'yyyy/MM/dd HH:mm:ss'),
      item.remarks,
      `IDR ${item.amount.toLocaleString()}`
    ]);

    const totalExpense = filteredData.reduce((acc, curr) => acc + curr.amount, 0).toLocaleString();

    doc.autoTable({
      head: [['Tanggal', 'Keterangan', 'Jumlah']],
      body: tableData,
      foot: [['', 'Total Pengeluaran', `IDR ${totalExpense}`]],
      startY: 20
    });

    doc.save('LaporanPengeluaranTenant.pdf');
  };

  useEffect(() => {
    getData();
  }, [paginationOptions.start_date, paginationOptions.end_date]);

  useEffect(() => {
    filterData(data);
  }, [paginationOptions.tenant_cost]);

  return (
    <div style={{ minHeight: 640 }}>
      <div className="d-flex justify-content-between align-items-end">
        <h1 className="text-30 lh-14 fw-600 mb-0">Pengeluaran</h1>
        <div className="d-flex align-items-end">
          <div className="me-2">
            <SelectMasterCost
              type="text"
              label="Master Biaya"
              isSolid={false}
              value={paginationOptions.tenant_cost}
              style="inline"
              onChange={(val) => handleFilterChange('tenant_cost', val)}
            />
          </div>
          <div className="me-2">
            <label className="fw-semibold text-14">Start Date</label>
            <input
              onKeyDown={(e) => e.preventDefault()}
              onChange={(e) => handleFilterChange('start_date', e.target.value)}
              value={paginationOptions.start_date}
              type="date"
              className="form-control"
              style={{ border: 'solid 1px #cccccc', backgroundColor: '#ffffff', width: 200 }}
            />
          </div>
          <div>
            <label className="fw-semibold text-14">End Date</label>
            <input
              onKeyUp={(e) => e.preventDefault()}
              onChange={(e) => handleFilterChange('end_date', e.target.value)}
              value={paginationOptions.end_date}
              type="date"
              className="form-control"
              style={{ border: 'solid 1px #cccccc', backgroundColor: '#ffffff', width: 200 }}
            />
          </div>
          <div className="ms-2">
            <button onClick={getData} className="btn btn-small text-white fw-semibold bg-blue-1">
              Filter Data
            </button>
          </div>
          <div className="ms-2">
            <button
              onClick={downloadExcel}
              className="btn btn-small text-white fw-semibold bg-success">
              Download Excel
            </button>
          </div>
          <div className="ms-2">
            <button
              onClick={downloadPdf}
              className="btn btn-small text-white fw-semibold bg-danger">
              Download PDF
            </button>
          </div>
        </div>
      </div>
      {loading && !error && (
        <div className="d-flex justify-content-center mt-60">
          <p className="fw-semibold text-blue-1">Loading...</p>
        </div>
      )}
      {!loading && error && (
        <div className="d-flex justify-content-center mt-60">
          <p className="fw-semibold text-dark">
            Gagal mendapatkan data,{' '}
            <span onClick={getData} className="cursor-pointer text-danger">
              Coba kembali
            </span>
          </p>
        </div>
      )}
      {!loading && !error && filteredData.length === 0 && (
        <div className="d-flex justify-content-center mt-60">
          <p className="fw-semibold text-blue-1">Data tidak ditemukan</p>
        </div>
      )}
      {!loading && !error && filteredData.length > 0 && (
        <table className="table table-border table-report mt-40">
          <thead>
            <tr>
              <th className="bg-blue-1 text-white rounded-0">Tanggal</th>
              <th className="bg-blue-1 text-white rounded-0">Keterangan</th>
              <th className="text-right bg-blue-1 text-white rounded-0">Jumlah</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((item) => (
              <tr key={item.id}>
                <td>{format(new Date(item.date), 'yyyy/MM/dd HH:mm:ss')}</td>
                <td>{item.remarks}</td>
                <td className="text-right">IDR {item.amount.toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan={2}>Total Pengeluaran</th>
              <th className="text-right">
                IDR {filteredData.reduce((acc, curr) => acc + curr.amount, 0).toLocaleString()}
              </th>
            </tr>
          </tfoot>
        </table>
      )}
    </div>
  );
};

export default Pengeluaran;
